import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { DynamicHtmlDirective, MenuContentItem, TrackingService, trackByProp } from '@frontend/vanilla/core';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ProfilePageNudgesService } from './profile-page-nudges.service';

@Component({
    imports: [TrustAsHtmlPipe, DynamicHtmlDirective, IconCustomComponent],
    selector: 'vn-profile-page-nudges',
    templateUrl: 'profile-page-nudges.html',
})
export class ProfilePageNudgesComponent implements OnInit, OnDestroy {
    items: MenuContentItem[] = [];
    readonly trackByProp = trackByProp<MenuContentItem>('id');

    private readonly unsubscribe = new Subject<void>();

    private readonly profilePageNudgesService = inject(ProfilePageNudgesService);
    private readonly trackingService = inject(TrackingService);

    ngOnInit() {
        this.profilePageNudgesService.displayItems.pipe(takeUntil(this.unsubscribe)).subscribe((items: MenuContentItem[]) => {
            this.items = items;
        });

        this.trackingService.triggerEvent('contentView', {
            'component.CategoryEvent': 'my profile',
            'component.LabelEvent': 'my hub',
            'component.ActionEvent': 'load',
            'component.PositionEvent': 'not applicable',
            'component.LocationEvent': 'my hub page',
            'component.EventDetails': 'dotted learning & onboarding section',
            'component.URLClicked': 'not applicable',
        });
    }

    hide(item: MenuContentItem) {
        this.profilePageNudgesService.hide(item);
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
